<template>
    <div class="container conclusion">
        <div class="row">
            <div class="col-12">
                <div class="headline h2">
                    <span>Zusammenfassung. Fast Geschafft!</span>
                </div>
            </div>

            <div class="col-6">
                <div class="fourthStep">
                    <div class="headline small-headline">
                        <span>Kontaktdaten <span class="edit" title="Noch mal bearbeiten"
                                                 v-on:click="$emit('jumpTo', 4)"><i
                                class="fa fa-pen"></i></span></span>
                    </div>
                    <div class="content">
                        <span>{{ this.$parent.fourthStepData.forename }} {{ this.$parent.fourthStepData.lastname }}, {{this.$parent.fourthStepData.gebdate | dateFormat }}</span><br>
                        <span>{{ this.$parent.fourthStepData.street }} {{ this.$parent.fourthStepData.streetnr }}</span><br>
                        <span>{{ this.$parent.fourthStepData.zip }} {{ this.$parent.fourthStepData.town }}</span><br>
                        <span>{{ this.$parent.fourthStepData.phone }}, {{ this.$parent.fourthStepData.mail }}</span>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="firstStep">
                    <span class="headline small-headline"
                          v-if="this.$parent.firstStepData.rows">Fächerangebot <span
                            class="edit" title="Noch mal bearbeiten" v-on:click="$emit('jumpTo', 1)"><i
                            class="fa fa-pen"></i></span></span>

                    <span v-for="(row, index) in this.$parent.firstStepData.rows" :key="index">
                        <b>{{ row.name }}</b>: <blockquote v-for="(year, yearIndex) in row.selectedYears"
                                                              :key="yearIndex">{{ year }}</blockquote>
                    </span>
                </div>
            </div>
            <div class="col-6">
                <div class="thirdStep">
                    <div class="headline small-headline">
                        <span>Qualifikation <span class="edit" title="Noch mal bearbeiten"
                                                  v-on:click="$emit('jumpTo', 3)"><i
                                class="fa fa-pen"></i></span></span>
                    </div>
                    <div class="content">
                        <span>{{ this.$parent.thirdStepData.selectedGraduations }} &emsp;∅ {{this.$parent.thirdStepData.cut }}</span><br>
                        <span v-if="typeof this.$parent.thirdStepData.selectedExperiences !== 'undefined' && this.$parent.thirdStepData.selectedExperiences.length > 0">Du hast Erfahrung im Nachhilfegeben.<br></span>
                        <span v-if="this.$parent.thirdStepData.experienceComment != ''">Dein Kommentar:  <i>{{this.$parent.thirdStepData.experienceComment}}</i><br></span>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="secondStep">
                    <div class="headline small-headline">
                        <span>Verkehrsmittel und Nachhilfeort <span class="edit" title="Noch mal bearbeiten"
                                                                    v-on:click="$emit('jumpTo', 2)"><i
                                class="fa fa-pen"></i></span></span>
                    </div>
                    <div class="content">
                        <span v-for="(mobility, index) in this.$parent.secondStepData.mobility" :key="index"><span
                                v-if="index != 0">, </span>{{ mobility }}</span><br>
                        <span>Wir werden Dich bei Nachhilfeanfragen <b>{{ this.$parent.secondStepData.radius }} km</b> um Deinen Wohnort kontaktieren.</span>
                    </div>
                </div>
            </div>
            <div class="col-9 input-group">
                <div class="">
                    <label class="checkbox" v-bind:class="{ 'invalid': errors.first('privacy') }">
                        <input type="checkbox" :value="'akzeptiert'" v-model="privacy" :name="'privacy'"
                               v-validate="'required'" data-vv-as="Datenschutzbestimmungen"> <span>Ich habe die&nbsp;<a
                            href="https://shop.mueller-helpings.de/Datenschutz-oxid/" target="_blank">Hinweise
                zum Datenschutz</a>&nbsp;gelesen und akzeptiere sie.</span>
                    </label>
                    <!--<span class="text-danger">{{ errors.first('privacy') }}</span>-->
                </div>
            </div>

            <div class="col-12 border-top">
                <div class="headline h2">
                    <span>Deine Motivation</span>
                </div>
                <p>Erzähl uns kurz, was Dich zur Nachhilfe motiviert und warum Du ein Teil von müller helpings werden möchtest!</p>
                <textarea placeholder="Deine Motivation" rows="4" v-model="motivation"
                          v-validate="'required'"></textarea>
            </div>

        </div>
        <div class="col-1"></div>

    </div>

</template>

<script>
    export default {
        name: 'conclusion',
        components: {},

        data: function () {
            return {
                motivation: '',
                privacy: '',
            }
        },

        mounted() {

        },

        methods: {
            nextPage() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        // Success
                        let description = 'Geburtstag: ' + this.$parent.fourthStepData.gebdate + '\r\n' +
                            'Qualifikation: ' + this.$parent.thirdStepData.selectedGraduations + ' Schnitt: ' + this.$parent.thirdStepData.cut + '\r\n' +
                            this.$parent.thirdStepData.selectedExperiences + ' – ' + this.$parent.thirdStepData.experienceComment + '\r\n ' +
                            'Radius: ' + this.$parent.secondStepData.radius + 'km – Verkehrsmittel: ' + this.$parent.secondStepData.mobility + '\r\n\r\n' +
                            'Fächer: ';
                        for (let key in this.$parent.firstStepData.rows) {
                            description = description + this.$parent.firstStepData.rows[key].name + ' ' + this.$parent.firstStepData.rows[key].selectedYears + ' – ';
                        }
                        description = description + '\r\n\r\n' + 'Motivation: ' + this.motivation;

                        // Send to CRM
                        this.$parent.apiPost('Teacher', {
                            firstName: this.$parent.fourthStepData.forename,
                            lastName: this.$parent.fourthStepData.lastname,
                            status: 'Bewerbung',
                            emailAddress: this.$parent.fourthStepData.mail,
                            phoneNumber: this.$parent.fourthStepData.phone,
                            addressStreet: this.$parent.fourthStepData.street + ' ' + this.$parent.fourthStepData.streetnr,
                            addressPostalCode: this.$parent.fourthStepData.zip,
                            addressCity: this.$parent.fourthStepData.town,
                            description: description,

                        });


                        this.$http
                            .post('https://api.mueller-helpings.de/mh/mail', {
                                    "to": [
                                        {"email": "nachhilfe@mueller-helpings.de", "name": "mueller-helpings"}
                                    ],
                                    "from": {"nachhilfe@mueller-helpings.de": "müller helpings Nachhilfe GbR"},
                                    "subject": "Neue Berwerbung eines Nachhilfelehrer/in",
                                    "body": `<p><b>Es hat sich ein neuer Nachhilfelehrer beworben: {{forename}} {{lastname}}</b></p>
                                             <p><strong>Bitte umgehend prüfen.</strong></p>`,
                                    "type": "html",
                                    "data": {
                                        forename: this.$parent.fourthStepData.forename,
                                        lastname: this.$parent.fourthStepData.lastname,
                                    }
                                }, {
                                    headers: {
                                        "Authorization": "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1Ni20",
                                        "Content-Type": "application/json"
                                    }
                                }
                            )
                            .then(response => (self.info = response))
                            .catch(error => console.log(error))

                        this.$http
                            .post('https://api.mueller-helpings.de/mh/mail', {
                                    "to": [
                                        {"email": this.$parent.fourthStepData.mail, "name": this.$parent.fourthStepData.forename + ' ' + this.$parent.fourthStepData.lastname}
                                    ],
                                    "from": {"nachhilfe@mueller-helpings.de": "müller helpings Nachhilfe GbR"},
                                    "subject": "Deine Berwerbung als Nachhilfelehrer/in",
                                    "body": `<p>Hallo {{firstName}} {{lastName}},</p>
                                             <p>vielen Dank für Deine Bewerbung! Wir werden diese prüfen und uns mit einem Feedback möglichst schnell bei Dir melden.</p><br>
                                             <p><b>Zusammenfassung Deiner übermittelten Daten:</b><br>
                                                 Vorname: {{firstName}} <br>
                                                 Nachname: {{lastName}}  <br>
                                                 E-Mail: {{emailAddress}} <br>
                                                 Telefonnummer: {{phoneNumber}} <br>
                                                 Adresse: {{addressStreet}} <br>
                                                 Postleitzahl: {{addressPostalCode}} <br>
                                                 Stadt:  {{addressCity}} <br>
                                                 {{description}}`,
                                    "type": "html",
                                    "data": {
                                        firstName: this.$parent.fourthStepData.forename,
                                        lastName: this.$parent.fourthStepData.lastname,
                                        emailAddress: this.$parent.fourthStepData.mail,
                                        phoneNumber: this.$parent.fourthStepData.phone,
                                        addressStreet: this.$parent.fourthStepData.street + ' ' + this.$parent.fourthStepData.streetnr,
                                        addressPostalCode: this.$parent.fourthStepData.zip,
                                        addressCity: this.$parent.fourthStepData.town,
                                        description: description,
                                    }
                                }, {
                                    headers: {
                                        "Authorization": "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1Ni20",
                                        "Content-Type": "application/json"
                                    }
                                }
                            )
                            .then(response => (self.info = response))
                            .catch(error => console.log(error))

                        this.$emit('openNextPage', this);
                        return;
                    }
                    if (
                        !result
                    ) {
                        // Error
                        this.showErrors = true;
                        console.log('error');
                        console.log(this);
                    }
                })
                ;
            }
        },

        filters: {
            dateFormat: function (value) {
                if (!value) return ''
                var d = new Date(value)
                return ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.' + d.getFullYear()
            }
        }
    }
</script>

<style lang="less">
    .conclusion {
        .col-6 {
            margin-bottom: 3rem;
        }

        span.edit {
            font-size: 1rem;
            color: #4e9aa2;
            cursor: pointer;
            margin-left: 0.75rem;
        }
    }

    blockquote {
        margin-top: 0;
        margin-bottom: 0;
    }
</style>